import { useQuery } from '@tanstack/vue-query'
import { computed, type MaybeRefOrGetter, toValue } from 'vue'
import { queryKeys } from '~/queryClient'
import { fetchTargetIncentivesSummary } from '~/services-v2/financial-bff/target-incentives-summary.gql'
import { INCENTIVES_QUERY_STALE_MS } from './incentivesQuery.constants'

interface UseTargetIncentivesSummaryParams {
  targetId: MaybeRefOrGetter<string | undefined>
  targetType: string
  campaignType: string
  enabled?: MaybeRefOrGetter<boolean>
}

export default function useTargetIncentivesSummary(params: UseTargetIncentivesSummaryParams) {
  const targetId = computed(() => toValue(params.targetId))

  const queryEnabled = computed(() => {
    const enabledParam = params.enabled === undefined ? true : Boolean(toValue(params.enabled))
    return enabledParam && !!targetId.value
  })

  return useQuery({
    queryKey: computed(() => queryKeys.INCENTIVES.TARGET_SUMMARY(targetId.value ?? '', params.targetType, params.campaignType)),
    enabled: queryEnabled,
    queryFn: () => fetchTargetIncentivesSummary({
      targetId: targetId.value!,
      targetType: params.targetType,
      campaignType: params.campaignType,
    }),
    staleTime: INCENTIVES_QUERY_STALE_MS,
  })
}
